import FacebookIcon from '@/components/icons/FacebookIcon'
import YoutubeIcon from '@/components/icons/YoutubeIcon'
import InstagramIcon from '@/components/icons/InstagramIcon'
import TikTokIcon from '@/components/icons/TikTokIcon'
import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { useContent } from '@/hooks/useContent'

interface SocialLinksProps {
  className?: string
  iconSize?: number
  /** Style du bouton rond — par défaut pensé pour un fond sombre (footer). */
  buttonClassName?: string
}

export default function SocialLinks({
  className = '',
  iconSize = 16,
  buttonClassName = 'w-9 h-9 bg-white/10 text-white hover:bg-white/20',
}: SocialLinksProps) {
  const { contact } = useContent()
  // Un réseau laissé vide dans l'admin n'est pas affiché.
  const channels = [
    { label: 'Facebook', url: contact.facebook, Icon: FacebookIcon },
    { label: 'Instagram', url: contact.instagram, Icon: InstagramIcon },
    { label: 'YouTube', url: contact.youtube, Icon: YoutubeIcon },
    { label: 'TikTok', url: contact.tiktok, Icon: TikTokIcon },
    { label: 'Chaîne WhatsApp', url: contact.whatsappChaine, Icon: WhatsAppIcon },
  ].filter((c) => c.url)

  return (
    <div className={`flex gap-3 ${className}`}>
      {channels.map(({ label, url, Icon }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} CMP Lubumbashi`}
          className={`rounded-full flex items-center justify-center transition-colors ${buttonClassName}`}
        >
          <Icon size={iconSize} />
        </a>
      ))}
    </div>
  )
}
